// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"727":"b7fddbdb","6199":"b7fddbdb","7823":"b7fddbdb","7913":"b7fddbdb"}[chunkId] + ".chunk.css";
};